class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    button.addEventListener('click', (event) => {
      button.toggleAttribute('open');
      button.closest('.parent-display').classList.toggle('show-more-expanded');
      this.expandShowMore(event);
      
      const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item')

      if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden')) {
        nextElementToFocus.querySelector('input').focus()
      }
    });
  }
  expandShowMore(event) {
    this.querySelectorAll('.label-text').forEach(element => element.classList.toggle('hidden'));
  }
}

customElements.define('show-more-button', ShowMoreButton);

